import React, { useState, useRef, useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import { Toast } from 'primereact/toast';
import { useAuth } from '../contexts/AuthContext';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const { logout, user, refreshUser } = useAuth();
  const toast = useRef(null);

  useEffect(() => {
    // Refresh user data on page load
    refreshUser();
  }, []);

  useEffect(() => {    
    setMenuItems([
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        command: () => navigate('/dashboard')
      },
      {
        label: 'My Horses',
        icon: 'pi pi-plus',
        command: () => navigate('/horses')
      },
      {
        label: 'My Rides',
        icon: 'pi pi-file',
        command: () => navigate('/rides')
      },
      ...(user?.member?.membership == "SE Admin" ? [{
        label: 'Ride Manager',
        icon: 'pi pi-stopwatch',
        command: () => navigate('/rideresults')
      },
      {
        label: 'Award Reports',
        icon: 'pi pi-trophy',
        command: () => navigate('/ridereports')
      },
      {
        label: 'Manage Horses',
        icon: 'pi pi-database',
        command: () => navigate('/manage-horses')
      }] : []),
      /*{
        label: 'Documents',
        icon: 'pi pi-book',
        command: () => navigate('/documents')
      }*/
    ]);
  }, [user]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const [menuItems, setMenuItems] = useState([]);

  const start = (
    <Link to="/dashboard" className="se-logo">
      <img 
        src="/logo.png" 
        alt="Sport Endurance" 
        className="se-header-logo"
      />
    </Link>
  );

  const end = (
    <div className="flex align-items-center gap-2">
      <Button 
        icon="pi pi-sign-out" 
        className="p-button-text p-button-plain"
        onClick={handleLogout}
        tooltip="Logout"
        tooltipOptions={{ position: 'left' }}
      />
    </div>
  );

  return (
    <div className="min-h-screen">
      <Toast ref={toast} />
      
      {/* Header */}
      <div className="se-header">
        <Menubar 
          model={menuItems} 
          start={start} 
          end={end}
          className="se-nav border-none"
        />
      </div>

      {/* Mobile Sidebar */}
      <Sidebar 
        visible={sidebarVisible} 
        position="left" 
        onHide={() => setSidebarVisible(false)}
        className="w-full sm:w-20rem"
      >
        <div className="p-3">
          <h3 className="se-text-primary mt-0">Menu</h3>
          {menuItems.map((item, index) => (
            <div key={index} className="mb-2">
              <Button
                label={item.label}
                icon={item.icon}
                className="w-full p-button-text justify-content-start"
                onClick={() => {
                  if (item.command) item.command();
                  setSidebarVisible(false);
                }}
              />
              {item.items && (
                <div className="ml-3 mt-1">
                  {item.items.map((subItem, subIndex) => (
                    <Button
                      key={subIndex}
                      label={subItem.label}
                      icon={subItem.icon}
                      className="w-full p-button-text justify-content-start text-sm"
                      onClick={() => {
                        if (subItem.command) subItem.command();
                        setSidebarVisible(false);
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </Sidebar>

      {/* Main Content */}
      <main className="p-4">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-top-1 border-200 p-4 mt-4">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-600 m-0">
            © {new Date().getFullYear()} Sport Endurance. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;